import type { FC } from 'react';

import { Line } from '@eneco/custom-components/Graph';
import { theme } from '@eneco/sparky/theme';
import { GridRows } from '@visx/grid';
import type { ScaleLinear } from 'd3-scale';



type Props = {
  yScale: ScaleLinear<number, number, never>;
  showOriginLine: boolean;
  width: number;
  height: number;
};

export const GridLines: FC<Props> = ({ yScale, showOriginLine, ...props }) => {
  const stroke = theme.colors.borderDividerLowEmphasis;
  return (
    <>
      <GridRows scale={yScale} stroke={stroke} tickValues={yScale.ticks(8)} {...props} />
      {showOriginLine ? <Line x1={0} x2={props.width} y1={yScale(0)} y2={yScale(0)} /> : null}
    </>
  );
};
